export const REPORT_EXTENSION_CSV = 'csv';
export const REPORT_EXTENSION_EXCEL = 'excel';
export const REPORT_EXTENSION_JSON = 'json';

/*SDPX Extension*/
export const SPDX_EXTENSION_JSON = 'json';
export const SPDX_EXTENSION_XML = 'xml';
export const SPDX_EXTENSION_RDF = 'rdf';
export const SPDX_EXTENSION_YAML = 'yaml';
export const SPDX_EXTENSION_TAG = 'spdx';
export const REPORT_EXTENSION_XLSX = 'xlsx';

export const REPORT_TYPE_OVERVIEW = 'overview';
export const REPORT_TYPE_IDENTIFIERS = 'identifiers';
export const REPORT_TYPE_ALL_DATA = 'all_data';
export const REPORT_BIRD_VIEW = 'bird_view';

export const SCANS_LABEL_ARCHIVE = 'Archive';
export const SCANS_LABEL_EXPORT = 'Export';
export const SCANS_LABEL_DELETE = 'Delete';
export const SCANS_LABEL_CANCEL = 'Cancel';

export const SFC_TEXT = 'Clarity has a module for determine copyleft compliance project of Software Freedom Conservancy. The current Software Freedom Conservancy known litigator module only reports for BusyBox. Today, they are doing a lot more than BusyBox. Conservancy does semi-regular compliance work for its BusyBox, Evergreen, Git, Inkscape, Mercurial, Samba, Sugar Labs and Wine member projects. We keep update their projects by crawling.';
export const SFC_LINK = 'SFC projects';
export const SFC_URL = 'https://sfconservancy.org/projects/current/';

export const MCHARDY_TEXT = 'Clarity has a module to detect copyright owned by Patrick McHardy. Our module currently detects McHardy code in the linux kernel network stack, Netfilter, iptables, iproute2 and BusyBox. There are various ways that these issues can be reported to companies using our solution such as what identifiers were matched, which files were matched or which kernel configurations were matched.';
export const MCHARDY_LINK = '';
export const MCHARDY_URL = '';

export const PATENTMODULE_TEXT = 'Clarity has a module for address patent claims. This is designed to detect claims against some code, the most recent high profile patent lawsuit launched regarding elliptic curve cryptography and potentially impacting certain configurations of the Open Source OpenSSL and LibreSSL libraries.';
export const PATENTMODULE_LINK = 'Example of patent claims';
export const PATENTMODULE_URL = 'http://www.reuters.com/article/blackberry-strategy-idUSL1N11N1RQ20150917';

//export const HTML_UNIQUE = 'unique';
export const HTML_ASSIGNED = 'assigned';
//export const HTML_UNMATCHED = 'unmatched';
export const HTML_NAMES = 'names';
export const HTML_FUNCTION_NAMES = 'functionnames';
export const HTML_ELF_REPORT = 'elfreport';

export const HTML_UNIQUE = 'unique_matches';
export const HTML_OTHER = 'other_matches';
export const HTML_UNMATCHED = 'no_matches';
export const HTML_IGNORE = 'ignored';
export const HTML_VARIABLE = 'variable_field_matches';
export const HTML_FUNCTION_UNIQUE = 'function_unique_matches';
export const HTML_FUNCTION_KERNEL = 'function_kernel_matches';
export const HTML_MANIFEST = 'manifest_matches';
export const HTML_HASH = 'hash_matches';
export const HTML_FUZZY = 'fuzzy_matches';

export const API_SCAN_CONFIG_US_DATABASE = 'us_national_vulnerability_database';
export const API_SCAN_CONFIG_FEDORA = 'fedora_security_reports';
export const API_SCAN_CONFIG_DEBIAN = 'debian_security_reports';
export const API_SCAN_CONFIG_VULN = 'vuln_db';
export const API_SCAN_CONFIG_LITIGATORS = 'known_litigators';
export const API_SCAN_CONFIG_COMPLEX_LICENSING = 'code_with_complex_licensing';
